import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { ERROR_MESSAGES } from "../../components/GlobalMassage";
import ReCAPTCHA from "react-google-recaptcha";
import { blogListForWebsite } from "../../../Services/Blog/BlogApi";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../Context/AuthContext";
import SuccessPopupModal from "../../components/SuccessPopupModal";
import { addUpdateEnquiry } from "../../../Services/EnqueryApi";

const TrafficSimulationAndSurveyDivision = () => {
  const [count, setCount] = useState(0);
  const [showPreloader, setShowPreloader] = useState(true);
  const [modelAction, setModelAction] = useState([]);

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const { setLoader, user } = useAuth();
  const [totalRecords, setTotalRecords] = useState(-1);
  const [totalPage, setTotalPage] = useState();
  const [searchKeyword, setSearchKeyword] = useState("");
  const [totalCount, setTotalCount] = useState(null);
  const [pageSize, setPageSize] = useState(30);
  const [blogListData, setBlogListData] = useState([]);

  //  const [bannerSlides,setBannerSlides]=useState([])

  const [error, setErrors] = useState(null);
  const [errorMessage, setErrorMessage] = useState();

  const [homeContactObj, setHomeContactObj] = useState({
    name: null,
    phoneNumber: null,
    message: null,
    email: null,
  });

  const [captchaToken, setCaptchaToken] = useState(null);
  const handleCaptcha = (token) => {
    setCaptchaToken(token);
  };

  const AddStateBtnClick = async () => {
    let isValid = false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    if (
      homeContactObj.firstName === null ||
      homeContactObj.firstName === undefined ||
      homeContactObj.firstName === "" ||
      homeContactObj.lastName === null ||
      homeContactObj.lastName === undefined ||
      homeContactObj.lastName === "" ||
      homeContactObj.phoneNumber === null ||
      homeContactObj.phoneNumber === undefined ||
      homeContactObj.phoneNumber === "" ||
      homeContactObj.phoneNumber?.length < 10 ||
      homeContactObj.message === null ||
      homeContactObj.message === undefined ||
      homeContactObj.message === "" ||
      homeContactObj.email === null ||
      homeContactObj.email === undefined ||
      !emailRegex.test(homeContactObj.email) ||
      homeContactObj.email === ""
    ) {
      setErrors(true);
      isValid = true;
    } else {
      setErrors(false);
      isValid = false;
    }

    const apiParam = {
      firstName: homeContactObj.firstName,
      message: homeContactObj.message,
      email: homeContactObj.email,
      phoneNumber: homeContactObj.phoneNumber,
      pageName: "header",
      serviceID: null,
      enquiryKeyID: null,
      lastName: homeContactObj.lastName,
    };

    if (!isValid) {
      AddUpdateStateData(apiParam);
    }
  };

  const AddUpdateStateData = async (apiParam) => {
    try {
      let url = "/addUpdateEnquiry"; // Default URL for Adding Data

      const response = await addUpdateEnquiry(url, apiParam);
      if (response) {
        if (response?.data?.statusCode === 200) {
          // setLoader(false);
          setShowSuccessModal(true);
          setModelAction("Enquiry Sent Successfully!"); //Do not change this naming convention
          setInitialData();
          // setIsAddUpdateActionDone(true);
        } else {
          // setLoader(false);
          setErrorMessage(response?.response?.data?.errorMessage);
        }
      }
    } catch (error) {
      //   setLoader(false);
      console.error(error);
    }
  };

  // useEffect(()=>{
  //   GetBannerListForWebsiteData()
  // },[])

  // const GetBannerListForWebsiteData = async () => {

  //   try {
  //     const data = await bannerListForWebsite();
  //     if (data?.data?.statusCode === 200) {
  //       setLoader(false);

  //       const rawData = data.data.responseData?.data || [];

  //       const formattedSlides = rawData.map((item) => ({
  //         id: item.BannerKeyID,
  //         title: item.BannerTitle || "",
  //         subtitle: item.BannerSubTitle || "",
  //         description: "", // Add if needed
  //         bgClass: "", // Optional styling class
  //         buttons: [], // Fill if your API has button data,
  //         image: item.BannerImage || "", // optional // You may need to confirm mime type (jpeg/png)

  //       }));

  //       setBannerSlides(formattedSlides);

  //     } else {
  //       setLoader(false);
  //       // Handle non-200 status codes if necessary
  //       console.error('Error fetching data: ', data?.data?.statusCode);
  //     }
  //   } catch (error) {
  //     setLoader(false);
  //     console.error('Error in Customer : ', error);
  //   }
  // };

  const setInitialData = () => {
    setHomeContactObj({
      ...homeContactObj,
      firstName: "",
      lastName: "",
      phoneNumber: "",
      message: "",
      email: "",
    });
    setErrors(false); // Reset error flag too
    setErrorMessage(false); // Optional if you're using this for custom messages
  };

  const closeAllModal = () => {
    setShowSuccessModal(false);
  };

  const getBreadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.big-strategic.com/",
      },
    ],
  };

  const getOrganizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Techno Land - Engineers & Surveyors",
    alternateName: "BIG Strategic Management Consultants",
    url: "https://www.big-strategic.com/",
    logo: "https://www.big-strategic.com/assets/img/logo/footer-new.png",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+91 7304502790",
      contactType: "customer service",
      contactOption: "TollFree",
      areaServed: "IN",
      availableLanguage: ["en", "Hindi"],
    },
  };

  const getWebPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Business Growth Strategies – BIG Strategic Management Consultants",
    url: "https://www.big-strategic.com/",
    description:
      "Get expert business consulting with BIG Strategic Management Consultants. We blend experience & innovation to drive success across industries worldwide. Let’s grow together.",
    publisher: {
      "@type": "Organization",
      name: "BIG Strategic",
    },
  };

  const getLocalBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "BIG Strategic Management Consultants",
    image: "https://www.big-strategic.com/assets/img/logo/footer-new.png",
    "@id": "",
    url: "https://www.big-strategic.com/",
    telephone: "+91 7304502790",
    address: {
      "@type": "PostalAddress",
      streetAddress: "A321, Lodha Supremus 2, Wagle Estate Road No.22",
      addressLocality: "400604",
      postalCode: "400604",
      addressCountry: "IN",
    },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      opens: "09:00",
      closes: "18:00",
    },
  };

  const navigate = useNavigate();

  const GetWebsiteBlogListData = async (pageNumber, searchKeywordValue) => {
    setLoader(true);
    try {
      const data = await blogListForWebsite({
        pageSize,
        pageNo: pageNumber - 1, // Page numbers are typically 0-based in API calls
        searchKeyword:
          searchKeywordValue === undefined ? searchKeyword : searchKeywordValue,
      });

      if (data) {
        if (data?.data?.statusCode === 200) {
          setLoader(false);
          if (data?.data?.responseData?.data) {
            const MasterStateListData = data.data.responseData.data;
            const totalItems = data.data?.totalCount; // const totalItems = 44;
            setTotalCount(totalItems);
            const totalPages = Math.ceil(totalItems / pageSize);
            setTotalPage(totalPages);
            setTotalRecords(MasterStateListData.length);
            setBlogListData(MasterStateListData);
          }
        } else {
          setErrorMessage(data?.data?.errorMessage);
          setLoader(false);
        }
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  return (
    <>
      <Helmet>
        <title>Traffic Simulation Survey in India



        </title>
        <meta
          name="description"
          content=" Plan safer roads and reduce congestion with our expert Traffic Simulation Survey. Accurate traffic flow analysis, actionable insights, and reliable reports."
        />
      </Helmet>
      <div
        class="rts-banner-area rts-section-gap rts-breadcrumb-area  position-relative contact-bd header-banner"
        style={{ height: "572px" }}
      >
        <div class="container">
          <div class="rts-contact-area-page rts-section-gap">
            <div class="container">
              <div class="row align-items-center">
                <div class="col-lg-6 pr--60 pr_sm--0 mb_sm--30 pr_md--10 pb_md--25 pb_sm--25">
                  <div class="contact-main-wrapper-left">
                    <h1
                      className="title-main new-servicehead"
                      style={{ color: "white", fontSize: "40px" }}
                    >
                      Traffic Simulation Survey{" "}
                      <span style={{ color: "#ef2830" }}> in India</span>
                    </h1>
                    <p class="disc" style={{ color: "white", marginBottom: "7px" }}>
                      Make traffic smoother and roads safer with our Traffic Simulation Survey services. We use smart tools and real traffic data to understand how vehicles move, where traffic slows down, the busiest times, and how roads are used. Our expert civil engineers build accurate models for highways, intersections, city roads, and public transport systems.</p>
                    <p class="disc" style={{ color: "white", marginTop: "0px" }}>
                      Whether you're planning a city project, designing a highway, or managing traffic for a big event, we give you clear reports and practical suggestions. With our easy-to-understand and reliable solutions, you save time, reduce costs, and make confident decisions for better traffic flow.



                    </p>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div id="form-messages"></div>
                  <div
                    class="contact-form-area-wrapper"
                    style={{ padding: "15px" }}
                  >
                    {/* <h4 class="title" style={{marginBottom:'5px',color:'#ef2830'}}>Let’s Get in Touch</h4> */}
                    <div class="half-inpur-wrapper">
                      <div class="single">
                        <input
                          type="text"
                          value={homeContactObj.firstName}
                          onChange={(e) => {
                            setErrorMessage(false);
                            let inputValue = e.target.value;

                            // Remove numbers and special characters, allow only letters and space
                            inputValue = inputValue.replace(/[^a-zA-Z\s]/g, "");

                            // Remove leading spaces
                            inputValue = inputValue.replace(/^\s+/, "");

                            // Capitalize first letter, rest lowercase (optional tweak)
                            inputValue =
                              inputValue.charAt(0).toUpperCase() +
                              inputValue.slice(1);

                            setHomeContactObj((prev) => ({
                              ...prev,
                              firstName: inputValue,
                            }));
                          }}
                          placeholder="First Name"
                        />
                        {error &&
                          (homeContactObj.firstName === null ||
                            homeContactObj.firstName === undefined ||
                            homeContactObj.firstName === "") ? (
                          <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                        ) : (
                          ""
                        )}
                      </div>
                      <div class="single">
                        <input
                          type="text"
                          value={homeContactObj.lastName}
                          onChange={(e) => {
                            setErrorMessage(false);
                            let inputValue = e.target.value;

                            // Remove numbers and special characters, allow only letters and space
                            inputValue = inputValue.replace(/[^a-zA-Z\s]/g, "");

                            // Remove leading spaces
                            inputValue = inputValue.replace(/^\s+/, "");

                            // Capitalize first letter, rest lowercase (optional tweak)
                            inputValue =
                              inputValue.charAt(0).toUpperCase() +
                              inputValue.slice(1);

                            setHomeContactObj((prev) => ({
                              ...prev,
                              lastName: inputValue,
                            }));
                          }}
                          placeholder="Last Name"
                        />
                        {error &&
                          (homeContactObj.lastName === null ||
                            homeContactObj.lastName === undefined ||
                            homeContactObj.lastName === "") ? (
                          <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                        ) : (
                          ""
                        )}{" "}
                      </div>
                    </div>
                    <div class="half-inpur-wrapper">
                      <div class="single">
                        <input
                          type="email"
                          value={homeContactObj.email}
                          onChange={(e) => {
                            setErrorMessage(false);
                            let InputValue = e.target.value;
                            const updatedValue = InputValue.replace(
                              /[^a-zA-Z0-9\s@&.\-_]/g,
                              ""
                            );
                            setHomeContactObj((prev) => ({
                              ...prev,
                              email: updatedValue,
                            }));
                          }}
                          placeholder="Email"
                        />
                        {error && (
                          <>
                            {homeContactObj.email === null ||
                              homeContactObj.email === undefined ||
                              homeContactObj.email === "" ? (
                              <span style={{ color: "red" }}>
                                {ERROR_MESSAGES}
                              </span>
                            ) : !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(
                              homeContactObj.email
                            ) ? (
                              <span style={{ color: "red" }}>
                                Please enter a valid email address.
                              </span>
                            ) : null}
                          </>
                        )}{" "}
                      </div>
                      <div class="single">
                        <input
                          maxLength={10}
                          placeholder=" Contact Number"
                          value={homeContactObj.phoneNumber}
                          onChange={(e) => {
                            setErrorMessage("");
                            const value = e.target.value;
                            let FormattedNumber = value.replace(/[^0-9]/g, ""); // Allows only numbers

                            // Apply regex to ensure the first digit is between 6 and 9
                            FormattedNumber = FormattedNumber.replace(
                              /^[0-5]/,
                              ""
                            );
                            setHomeContactObj((prev) => ({
                              ...prev,
                              phoneNumber: FormattedNumber,
                            }));
                          }}
                        />
                        {error && (
                          <span style={{ color: "red" }}>
                            {homeContactObj.phoneNumber === null
                              ? ERROR_MESSAGES
                              : homeContactObj.phoneNumber?.length < 10
                                ? "Invalid phone number"
                                : ""}
                          </span>
                        )}{" "}
                      </div>
                    </div>
                    <textarea
                      rows="4"
                      value={homeContactObj.message}
                      onChange={(e) => {
                        setErrorMessage(false);
                        let InputValue = e.target.value;
                        const updatedValue = InputValue.replace(
                          /[^a-zA-Z0-9\s@&.\-_]/g,
                          ""
                        );
                        setHomeContactObj((prev) => ({
                          ...prev,
                          message: updatedValue,
                        }));
                      }}
                      placeholder="Your Message"
                    ></textarea>
                    <div className="single">
                      <ReCAPTCHA
                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                        onChange={handleCaptcha}
                      />
                    </div>
                    {error &&
                      (homeContactObj.message === null ||
                        homeContactObj.message === undefined ||
                        homeContactObj.message === "") ? (
                      <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                    ) : (
                      ""
                    )}{" "}
                    <button
                      onClick={AddStateBtnClick}
                      class="rts-btn btn-primary"
                      style={{ marginTop: "20px" }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
              {showSuccessModal && (
                <SuccessPopupModal
                  show={showSuccessModal}
                  onHide={() => closeAllModal()}
                  setShowSuccessModal={setShowSuccessModal}
                  modelAction={modelAction}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <div
        class="about-service-main-wrapper rts-section-gap bg_white"
        id="about"
      >
        <div class="container">
          <div class="row align-items-center">
            <div class="col-xl-5 order-md-1 order-2">
              <div class="thumbnail-main-wrapper-2">
                <div class="reveal-item overflow-hidden aos-init">
                  <div class="" data-aos="reveal-end"></div>
                  <img src="assets/images/about/tra1.png" alt="traffic-survey" />
                </div>
              </div>
            </div>
            <div class="col-xl-7 pl--60 pl_md--0 pl_sm--10 pt_md--30 pt_sm--30 order-md-2 order-1">
              <div class="about-content-area-two">
                <div class="title-style-two-left">
                  <div class="title-left-align-five">
                    <h2 class="title mb--30">Why Choose Us</h2>
                  </div>

                  <p class="disc">
                    At Technoland, we deliver fast, precise, and reliable traffic simulation services using advanced software and experienced engineers. Our detailed, easy-to-understand reports help you plan safer roads, optimise intersections, reduce congestion, and improve overall traffic flow. With cost-effective solutions and professional support, we ensure informed decisions for every traffic management project.


                  </p>

                  <ul class="subservice-link">
                    <li>Precise and actionable simulation reports


                    </li>
                    <li>Skilled civil engineering team


                    </li>
                    <li>Latest software & modelling tools



                    </li>
                    <li>Quick turnaround & easy‑to‑understand results



                    </li>
                    <li>Transparent, affordable pricing



                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="rts-offer-area-start rts-section-gap">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="title-style-two-center inner">
                <h2 class="title mb--0">Services We Provide</h2>
                <p className="main mb--40">
                  We offer innovative traffic simulation solutions to improve road safety, reduce congestion, and optimize traffic flow.



                </p>
              </div>
            </div>
          </div>
          <div class="row g-24">
            <div class="col-lg-4 col-md-12 col-12">
              <div class="single-offer-inner">
                <div class="content-area">
                  <a href="#" class="title">
                    <h3 class="title">1. Advanced Traffic Planning Solutions
                    </h3>
                  </a>
                  <p class="disc">
                    We analyse traffic flow patterns, vehicle movement, and congestion hotspots to plan roads, junctions, and intersections efficiently, ensuring smooth and safe traffic movement.




                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12 col-12">
              <div class="single-offer-inner">
                <div class="content-area">
                  <a href="#" class="title">
                    <h3 class="title">2. Intersection Design Simulation

                    </h3>
                  </a>
                  <p class="disc">
                    We simulate intersections to test vehicle, pedestrian, and signal timings. This ensures minimal waiting times and safe crossing, reducing accidents and delays.



                    {" "}
                  </p>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-12 col-12">
              <div class="single-offer-inner">
                <div class="content-area">
                  <a href="#" class="title">
                    <h3 class="title">3. Urban Traffic Modelling
                    </h3>
                  </a>
                  <p class="disc">
                    Our team models traffic in urban areas using real-world data, helping municipalities plan roads, parking, and public transport effectively.


                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12 col-12">
              <div class="single-offer-inner">
                <div class="content-area">
                  <a href="#" class="title">
                    <h3 class="title">4. Highway Traffic Analysis
                    </h3>
                  </a>
                  <p class="disc">
                    We evaluate highway traffic density, speed patterns, and bottlenecks. This data helps design safer and more efficient highways with better flow.




                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12 col-12">
              <div class="single-offer-inner">
                <div class="content-area">
                  <a href="#" class="title">
                    <h3 class="title">5. Public Transport Simulation
                    </h3>
                  </a>
                  <p class="disc">
                    We simulate bus routes, metro lines, and transport hubs to optimise schedules, reduce delays, and improve commuter experience.


                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12 col-12">
              <div class="single-offer-inner">
                <div class="content-area">
                  <a href="#" class="title">
                    <h3 class="title">6. Event Traffic Management</h3>
                  </a>
                  <p class="disc">
                    We plan traffic movement for large events, festivals, or construction zones. Simulation ensures smooth flow, preventing congestion and accidents during peak times.


                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="rts-offer-area-start rts-section-gap testimunal-new"
        style={{ backgroundColor: "white" }}
      >
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="title-style-two-center inner">
                <h2 class="title mb--40">What Our Clients Say</h2>
              </div>
            </div>
          </div>
          <div class="row g-24">
            <div class="col-lg-4 col-md-12 col-12">
              <div
                class="single-offer-inner"
                style={{ backgroundColor: "#000000ff" }}
              >
                <div class="content-area">
                  <a href="#" class="title">
                    <p
                      class="title"
                      style={{
                        fontSize: "25px",
                        marginBottom: "20px",
                        color: "white",
                      }}
                    >
                      Ramesh Gupta




                    </p>
                  </a>
                  <p class="disc client-content">
                    <span
                      style={{
                        fontSize: "50px",
                        color: "white",
                      }}
                    >
                      “
                    </span>
                    Technoland’s traffic simulation helped our city plan a busy junction. Their analysis was clear and easy to understand. Excellent service!
                  </p>
                  <span
                    style={{
                      fontSize: "50px",
                      color: "white",
                    }}
                  >
                    ”
                  </span>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12 col-12">
              <div
                class="single-offer-inner"
                style={{ backgroundColor: "#ef2830" }}
              >
                <div class="content-area">
                  <a href="#" class="title">
                    <p
                      class="title"
                      style={{
                        fontSize: "25px",
                        marginBottom: "20px",
                        color: "white",
                      }}
                    >
                      {" "}
                      Anjali Sharma




                    </p>
                  </a>
                  <p class="disc client-content">
                    <span
                      style={{
                        fontSize: "50px",
                        color: "white",
                      }}
                    >
                      “
                    </span>
                    The team provided a detailed traffic report for our new highway project. Their insights saved time and reduced traffic risks significantly.
                  </p>
                  <span
                    style={{
                      fontSize: "50px",
                      color: "#ffffffff",
                    }}
                  >
                    ”
                  </span>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-12 col-12">
              <div
                class="single-offer-inner"
                style={{ backgroundColor: "#000000ff" }}
              >
                <div class="content-area">
                  <a href="#" class="title">
                    <p
                      class="title"
                      style={{
                        fontSize: "25px",
                        marginBottom: "20px",
                        color: "#ffffffff",
                      }}
                    >
                      Vikram Singh



                    </p>
                  </a>

                  <p class="disc client-content">
                    <span
                      style={{
                        fontSize: "50px",
                        color: "#ffffffff",
                      }}
                    >
                      “
                    </span>
                    Professional and reliable engineers. The traffic simulation survey helped us redesign intersections safely and efficiently. Highly recommended!
                  </p>
                  <span
                    style={{
                      fontSize: "50px",
                      color: "#ffffffff",
                    }}
                  >
                    ”
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="why-choose-us-area rts-section-gap demo-1"
        style={{ paddingTop: "10px" }}
      >
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="title-center-style-one dark-title">
                <span class="pre">Your Questions, Answered</span>
                <h2 class="title">Frequently Asked Questions</h2>
              </div>
            </div>
          </div>
          <div class="row align-items-center">
            <div class="col-xl-6 col-lg-12 ">
              <div class="faq-inner-one">
                <div class="accordion" id="accordionExample">
                  <div class="accordion-item active">
                    <h2 class="accordion-header" id="headingOne">
                      <button
                        class="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        Why is traffic simulation important?


                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      class="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        It helps plan safer roads, optimise intersections, reduce congestion, and improve overall traffic management for cities, highways, and events.

                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        Who can benefit from this survey?

                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        Urban planners, highway authorities, construction companies, municipal corporations, and event managers can use it to design efficient traffic systems.

                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFour">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        Can the survey help reduce accidents?


                      </button>
                    </h2>
                    <div
                      id="collapseFour"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        Yes. By analysing traffic patterns, bottlenecks, and intersections, we provide recommendations that increase safety and reduce accident risks.


                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFive">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive"
                        aria-expanded="false"
                        aria-controls="collapseFive"
                      >
                        Is the report easy to understand for non-technical people?

                      </button>
                    </h2>
                    <div
                      id="collapseFive"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingFive"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        Yes. Our reports are presented in simple language with charts, diagrams, and clear explanations for easy decision-making.



                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingSix">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSix"
                        aria-expanded="false"
                        aria-controls="collapseSix"
                      >
                        How much does a traffic simulation survey cost?

                      </button>
                    </h2>
                    <div
                      id="collapseSix"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingSix"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        Pricing depends on project size, location, and complexity. We offer transparent, affordable rates tailored to your specific traffic management needs.

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-6 col-lg-12 ">
              <div class="faq-inner-one " style={{ marginTop: "0px" }}>
                <div class="" data-aos="reveal-end"></div>
                <img src="assets/images/about/cta11-new.png" alt="journey-area" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TrafficSimulationAndSurveyDivision;
